import React from "react";
import classes from "./loading.module.css";

export default function LoadingSpinner() {
  return <div className={classes.loader}>Loading...</div>;
}
